module.exports = __webpack_public_path__ + "static/media/brand-refresh-work.ea96d391.svg";